export default "/images/fae00f49f896b596db566eb54b31ace1.avif";